{
  "COMPOSE_REDIRECT": {
    "OPENING": "Открывается новый диалог с {email}…",
    "NO_EMAIL": "Адрес электронной почты не указан. Используйте ?email=name@example.com",
    "CONTACT_ERROR": "Не удалось найти контакт для {email}."
  },
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Пожалуйста, выберите диалог из левой панели",
    "CSAT_REPLY_MESSAGE": "Пожалуйста, оцените диалог",
    "404": "Мы не можем найти диалог. Пожалуйста, попробуйте еще раз",
    "SWITCH_VIEW_LAYOUT": "Переключить вид",
    "DASHBOARD_APP_TAB_MESSAGES": "Сообщения",
    "UNVERIFIED_SESSION": "Подлинность этого пользователя не подтверждена",
    "NO_MESSAGE_1": "Ой! Похоже, сообщений от клиентов нет.",
    "NO_MESSAGE_2": " чтобы отправить сообщение на вашу страницу!",
    "NO_INBOX_1": "Алоха! Похоже, вы еще не добавили ни одного источника.",
    "NO_INBOX_2": " для начала",
    "NO_INBOX_AGENT": "Ой! Похоже, вы не добавлены ни к одному источнику сообщений. Обратитесь к администратору",
    "SEARCH_MESSAGES": "Поиск по сообщениям в диалогах",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Перевод",
    "EMPTY_STATE": {
      "CMD_BAR": "открыть меню команд",
      "KEYBOARD_SHORTCUTS": "для просмотра быстрых клавиш"
    },
    "SEARCH": {
      "TITLE": "Поиск сообщений",
      "RESULT_TITLE": "Результаты поиска",
      "LOADING_MESSAGE": "Сохранение данных...",
      "PLACEHOLDER": "Введите любой текст для поиска сообщений",
      "NO_MATCHING_RESULTS": "Результаты не найдены."
    },
    "UNREAD_MESSAGES": "Непрочитанные сообщения",
    "UNREAD_MESSAGE": "Непрочитанное сообщение",
    "CLICK_HERE": "Нажмите здесь",
    "LOADING_INBOXES": "Загружаем источники",
    "LOADING_CONVERSATIONS": "Загрузка диалогов",
    "CANNOT_REPLY": "Вы не можете ответить из-за",
    "24_HOURS_WINDOW": "Ограничение на 24 часа",
    "NOT_ASSIGNED_TO_YOU": "Этот диалог вам не назначен. Вы хотите назначить этот диалог себе?",
    "ASSIGN_TO_ME": "Назначить мне",
    "TWILIO_WHATSAPP_CAN_REPLY": "Вы можете ответить в этой беседе только с помощью шаблона сообщения",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "Ограничение на 24 часа",
    "REPLYING_TO": "Вы отвечаете на:",
    "REMOVE_SELECTION": "Удалить выделенное",
    "DOWNLOAD": "Скачать",
    "UNKNOWN_FILE_TYPE": "Неизвестный файл",
    "SAVE_CONTACT": "Сохранить контакт",
    "NO_CONTENT": "Нет содержимого для отображения",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Перед отправкой выполните:",
      "EXECUTE": "Выполнить",
      "RETRY": "Повторить",
      "CONFIRM": "Выполнить сейчас?",
      "CONFIRM_YES": "Да, выполнить",
      "CONFIRM_NO": "Отмена",
      "RUNNING": "Выполняется…",
      "DONE": "Выполнено",
      "CLAIM_DELAYED": "будет оформлена после доставки заказа",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "Создана НОВАЯ претензия {reference}, {planned} закрыта — измените текст черновика",
        "NEW_CLAIM": "Создана НОВАЯ претензия {reference} вместо обновления {planned} — измените текст черновика",
        "OTHER_CLAIM": "Обновлена претензия {reference} вместо {planned} — измените текст черновика",
        "EXISTING_CLAIM": "Новая претензия не создана, обновлена существующая {reference} — измените текст черновика",
        "OTHER": "Всё прошло иначе, чем предполагал черновик — измените текст черновика"
      },
      "FAILED": "Не удалось",
      "UNREACHABLE": "Бот недоступен",
      "REQUEST_FAILED": "Не удалось запустить действие, попробуйте ещё раз.",
      "ACTIONS": {
        "CANCEL_ORDER": "Отменить заказ",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Изменить оплату на наложенный платёж",
        "CREATE_CLAIM": "Оформить претензию",
        "CREATE_OR_UPDATE_CLAIM": "Оформить или обновить претензию",
        "EXTEND_ORDER_PICKUP_DATE": "Продлить срок получения"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} поделился контактом",
      "LOCATION": "{sender} поделился местоположением",
      "FILE": "{sender} поделился файлом"
    },
    "UPLOADING_ATTACHMENTS": "Загрузка вложений...",
    "REPLIED_TO_STORY": "Ответил на вашу историю",
    "UNSUPPORTED_MESSAGE": "Это сообщение не поддерживается. Вы можете просмотреть это сообщение в приложении Facebook / Instagram.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "Это сообщение не поддерживается. Вы можете просмотреть это сообщение в приложении Facebook Messenger.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "Это сообщение не поддерживается. Вы можете просмотреть это сообщение в приложении Instagram.",
    "SUCCESS_DELETE_MESSAGE": "Сообщение успешно удалено",
    "FAIL_DELETE_MESSSAGE": "Не удалось удалить сообщение! Попробуйте еще раз",
    "NO_RESPONSE": "Нет ответа",
    "RESPONSE": "Ответ",
    "RATING_TITLE": "Оценка",
    "FEEDBACK_TITLE": "Обратная связь",
    "REPLY_MESSAGE_NOT_FOUND": "Сообщение недоступно",
    "CARD": {
      "SHOW_LABELS": "Показать метки",
      "HIDE_LABELS": "Скрыть метки"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Завершить",
      "REOPEN_ACTION": "Открыть заново",
      "OPEN_ACTION": "Открыть",
      "OPEN": "Открыть",
      "CLOSE": "Закрыть",
      "DETAILS": "подробности",
      "SNOOZED_UNTIL": "Отложить до",
      "SNOOZED_UNTIL_TOMORROW": "Отложено до завтра",
      "SNOOZED_UNTIL_NEXT_WEEK": "Отложено до следующей недели",
      "SNOOZED_UNTIL_NEXT_REPLY": "Отложить до следующего ответа",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "пропущенный",
        "DUE": "до"
      },
      "MORE": "More actions"
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Отметить как ожидающие",
      "SNOOZE_UNTIL": "Отложено",
      "SNOOZE": {
        "TITLE": "Отложить до",
        "NEXT_REPLY": "Следующий ответ",
        "TOMORROW": "Завтра",
        "NEXT_WEEK": "На следующей неделе"
      },
      "RESOLVE_WITHOUT_CSAT": "Resolve without CSAT"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Отложить до",
      "APPLY": "Отложено",
      "CANCEL": "Отменить"
    },
    "PRIORITY": {
      "TITLE": "Приоритет",
      "OPTIONS": {
        "NONE": "Ничего",
        "URGENT": "Срочность",
        "HIGH": "Высокая",
        "MEDIUM": "Средняя",
        "LOW": "Низкая"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Ничего",
        "INPUT_PLACEHOLDER": "Выберите приоритет",
        "NO_RESULTS": "Результаты не найдены",
        "SUCCESSFUL": "Изменен приоритет разговора id {conversationId} на {priority}",
        "FAILED": "Не удалось изменить приоритет. Пожалуйста, попробуйте еще раз."
      }
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Открыть в новой вкладке",
      "COPY_LINK": "Копировать ссылку на диалог",
      "COPY_LINK_SUCCESS": "Ссылка на диалог скопирована в буфер обмена",
      "PENDING": "Отметить как ожидающие",
      "RESOLVED": "Пометить как разрешено",
      "MARK_AS_UNREAD": "Отметить как непрочитанное",
      "MARK_AS_READ": "Отметить как прочитанное",
      "REOPEN": "Переоткрыть разговор",
      "SNOOZE": {
        "TITLE": "Отложено",
        "NEXT_REPLY": "До следующего ответа",
        "TOMORROW": "До завтра",
        "NEXT_WEEK": "До следующей недели"
      },
      "ASSIGN_AGENT": "Назначить агента",
      "ASSIGN_LABEL": "Назначить метки",
      "AGENTS_LOADING": "Загрузка агентов...",
      "ASSIGN_TEAM": "Назначить команду",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "ID разговора {conversationId} присвоен \"{agentName}\"",
          "FAILED": "Не удалось назначить агента. Пожалуйста, попробуйте еще раз."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Назначена метка #{labelName} диалогу {conversationId}",
          "FAILED": "Не удалось назначить метку. Пожалуйста, попробуйте еще раз."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Назначена метка #{team} в разговор id {conversationId}",
          "FAILED": "Не удалось назначить команду. Пожалуйста, попробуйте еще раз."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Подпись сообщения",
      "ENABLE_SIGN_TOOLTIP": "Включить подпись",
      "DISABLE_SIGN_TOOLTIP": "Отключить подпись",
      "MSG_INPUT": "Shift + enter чтобы начать новую строку. Начните с '/', чтобы выбрать шаблонный ответ.",
      "PRIVATE_MSG_INPUT": "Shift + enter для новой строки. Это будет видно только Операторам",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Подпись сообщения не настроена, пожалуйста настройте её в настройках профиля.",
      "CLICK_HERE": "Нажмите здесь, чтобы обновить",
      "WHATSAPP_TEMPLATES": "Шаблоны Whatsapp",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "24-часовое окно WhatsApp истекло. Ответьте шаблонным сообщением.",
      "INSERT_SIGNATURE": "Insert signature into editor",
      "SIGNATURE_PREVIEW_IMAGE": "(image signature)"
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Похоже, ваш ответ написан на языке {draftLanguage}, но этот разговор ведётся на {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Перевести",
      "REPLY": "Ответить",
      "PRIVATE_NOTE": "Личная заметка",
      "SEND": "Отправить",
      "CREATE": "Добавить заметку",
      "INSERT_READ_MORE": "Читать далее",
      "DISMISS_REPLY": "Удалить ответ",
      "REPLYING_TO": "Ответить:",
      "TIP_FORMAT_ICON": "Показать редактор текста",
      "HEADING_LEVEL": {
        "LABEL": "Стиль текста",
        "NORMAL": "Обычный текст",
        "H1": "Заголовок 1",
        "H2": "Заголовок 2",
        "H3": "Заголовок 3"
      },
      "EDITOR": {
        "BOLD": "Жирный",
        "ITALIC": "Курсив",
        "UNDERLINE": "Подчёркнутый",
        "TEXT_COLOR": "Цвет текста",
        "BG_COLOR_LABEL": "Цвет фона",
        "FONT_SIZE_LABEL": "Размер шрифта",
        "FONT_SIZE": {
          "XS": "Маленький",
          "SM": "Средне-маленький",
          "MD": "Обычный",
          "LG": "Крупный",
          "XL": "Очень крупный",
          "XXL": "Огромный"
        },
        "CODE": "Код",
        "LINK": "Добавить или удалить ссылку",
        "CREATE_LINK": "Создать ссылку",
        "SAVE_LINK": "Сохранить",
        "CANCEL": "Отмена",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Отменить",
        "REDO": "Повторить",
        "BULLET_LIST": "Маркированный список",
        "ORDERED_LIST": "Нумерованный список",
        "BLOCKQUOTE": "Цитата",
        "H1": "Заголовок 1",
        "H2": "Заголовок 2",
        "H3": "Заголовок 3",
        "IMAGE_UPLOAD": "Загрузить изображение",
        "CLEAR_FORMATTING": "Очистить форматирование",
        "COLOR": {
          "RED": "Красный",
          "YELLOW": "Жёлтый",
          "BLUE": "Синий",
          "ROSE_RED": "Розово-красный",
          "DEEP_CYAN": "Тёмно-бирюзовый",
          "ORANGE": "Оранжевый",
          "PISTACHIO": "Фисташковый",
          "PURPLE": "Фиолетовый",
          "FUCHSIA": "Фуксия",
          "SILVER": "Серебристый",
          "NAVY": "Тёмно-синий",
          "OLD_PINK": "Пыльно-розовый",
          "AQUA": "Аквамарин",
          "BROWN": "Коричневый",
          "OLIVE": "Оливковый",
          "GOLD": "Золотой",
          "BEIGE": "Бежевый",
          "WINE": "Винный",
          "FOREST": "Тёмно-зелёный",
          "GREEN": "Зелёный",
          "BLUE_GREY": "Серо-синий",
          "RUBY_RED": "Рубиновый",
          "CHESTNUT_BROWN": "Каштановый",
          "ASH_GREY": "Пепельно-серый"
        },
        "BG_COLOR": {
          "RED": "Красный",
          "YELLOW": "Жёлтый",
          "BLUE": "Синий",
          "ROSE_RED": "Розово-красный",
          "DEEP_CYAN": "Тёмно-бирюзовый",
          "ORANGE": "Оранжевый",
          "PISTACHIO": "Фисташковый",
          "PURPLE": "Фиолетовый",
          "FUCHSIA": "Фуксия",
          "SILVER": "Серебристый",
          "NAVY": "Тёмно-синий",
          "OLD_PINK": "Пыльно-розовый",
          "AQUA": "Аквамарин",
          "BROWN": "Коричневый",
          "OLIVE": "Оливковый",
          "GOLD": "Золотой",
          "BEIGE": "Бежевый",
          "WINE": "Винный",
          "FOREST": "Тёмно-зелёный",
          "GREEN": "Зелёный",
          "BLUE_GREY": "Серо-синий",
          "RUBY_RED": "Рубиновый",
          "CHESTNUT_BROWN": "Каштановый",
          "ASH_GREY": "Пепельно-серый"
        }
      },
      "TIP_EMOJI_ICON": "Показать emoji панель",
      "TIP_ATTACH_ICON": "Прикрепить файлы",
      "TIP_AUDIORECORDER_ICON": "Записать аудио",
      "TIP_AUDIORECORDER_PERMISSION": "Разрешить доступ к аудио",
      "TIP_AUDIORECORDER_ERROR": "Не удалось открыть аудио",
      "DRAG_DROP": "Перетащите сюда, чтобы прикрепить",
      "START_AUDIO_RECORDING": "Начать запись аудио",
      "STOP_AUDIO_RECORDING": "Остановить запись аудио",
      "": "",
      "EMAIL_HEAD": {
        "TO": "ДО",
        "ADD_BCC": "Добавить bcc",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "Письма, разделенные запятыми",
          "ERROR": "Пожалуйста, введите действительный адрес электронной почты"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "Письма, разделенные запятыми",
          "ERROR": "Пожалуйста, введите действительный адрес электронной почты"
        },
        "EDIT": "Edit",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Hide",
        "INCLUDE_ORIGINAL_MESSAGE": "Include original message",
        "EDIT_HEADERS": "Edit",
        "HIDE_HEADER_EDITS": "Hide edits",
        "SUBJECT": {
          "LABEL": "SUBJECT",
          "PLACEHOLDER": "Email subject",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Неопределенные переменные",
        "MESSAGE": "У Вас {undefinedVariablesCount} неопределённых переменных в сообщении: {undefinedVariables}. Вы действительно хотите отправить сообщение?",
        "CONFIRM": {
          "YES": "Отправить",
          "CANCEL": "Отменить"
        }
      },
      "SEND_EMAIL": "Send email",
      "SEND_SMS": "Send SMS",
      "NO_SMS_INBOX": "Добавьте источник SMS, чтобы отправлять ответы по SMS.",
      "SEND_CHAT": "Send chat",
      "REPLY_TO_THIS": "Reply to this",
      "TIP_EXPAND_ICON": "Enlarge editor",
      "TIP_COLLAPSE_ICON": "Shrink editor",
      "COPILOT": {
        "Q": "Ask robot for help"
      }
    },
    "VISIBLE_TO_AGENTS": "Приватная заметка: видна только вам и вашей команде",
    "CHANGE_STATUS": "Статус разговора изменен",
    "CHANGE_STATUS_FAILED": "Не удалось изменить статус диалога",
    "CHANGE_AGENT": "Назначенный оператор изменен",
    "CHANGE_AGENT_FAILED": "Не удалось изменить назначение",
    "ASSIGN_LABEL_SUCCESFUL": "Метка успешно назначена",
    "ASSIGN_LABEL_FAILED": "Назначение метки не удалось",
    "CHANGE_TEAM": "Команда назначенная в беседу изменена",
    "FILE_SIZE_LIMIT": "Превышен лимит вложений в {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB",
    "MESSAGE_ERROR": "Не удается отправить это сообщение, повторите попытку позже",
    "SENT_BY": "Отправитель:",
    "BOT": "Бот",
    "SEND_FAILED": "Не удалось удалить сообщение! Попробуйте еще раз",
    "TRY_AGAIN": "повторить",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Выбрать Агента",
      "REMOVE": "Удалить",
      "ASSIGN": "Назначить"
    },
    "CONTEXT_MENU": {
      "COPY": "Копировать",
      "REPLY_TO": "Ответить на это сообщение",
      "DELETE": "Удалить",
      "CREATE_A_CANNED_RESPONSE": "Добавить в шаблонные ответы",
      "TRANSLATE": "Перевести",
      "COPY_PERMALINK": "Скопировать ссылку на сообщение",
      "LINK_COPIED": "Ссылка на сообщение скопирована",
      "DELETE_CONFIRMATION": {
        "TITLE": "Вы действительно хотите удалить это сообщение?",
        "MESSAGE": "Вы не можете отменить это действие",
        "DELETE": "Удалить",
        "CANCEL": "Отменить"
      },
      "FORWARD": "Foward",
      "FORWARD_ERROR": "Failed to prepare forwarded message"
    },
    "SIDEBAR": {
      "CONTACT": "Контакт",
      "COPILOT": "Copilot"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "{userName} завершил диалог",
          "CONTACT_RESOLVED": "Разговор был закрыт {contactName}",
          "OPEN": "{userName} открыл заново диалог",
          "PENDING": "Разговор был помечен как ожидающий {userName}",
          "SNOOZED": "Разговор был помечен как отложенный {userName}",
          "AUTO_RESOLVED": "Разговор был помечен системой решённым из-за неактивности в течение {duration} дней",
          "SYSTEM_AUTO_OPEN": "Система переоткрыла разговор из-за нового входящего сообщения.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "Conversation was marked resolved by {userName} (without CSAT)",
          "AUTO_RESOLVED_INACTIVE": "Conversation was marked resolved by system due to {duration} hours of inactivity",
          "AUTO_RESOLVED_EMPTY": "Conversation was marked resolved by system due to being empty.",
          "BLOCKED_CONTACT_RESOLVED": "System resolved the conversation because the contact is blocked.",
          "KAUFLAND_TICKET_CLOSED": "Система пометила разговор решённым, так как тикет был закрыт на Kaufland."
        },
        "PRIORITY": {
          "ADDED": "{userName} установил приоритет на {newPriority}",
          "UPDATED": "{userName} изменил приоритет с {oldPriority} на {newPriority}",
          "REMOVED": "{userName} удалил приоритет"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} назначил(а) разговор себе",
          "ASSIGNED": "{userName} назначил {assigneeName} ответственным",
          "REMOVED": "Ответственный снят {userName}"
        },
        "TEAM": {
          "ASSIGNED": "{userName} назначил {teamName} ответственным",
          "ASSIGNED_WITH_ASSIGNEE": "{userName} назначил {assigneeName} в {teamName}",
          "REMOVED": "{userName} исключил из {teamName}"
        },
        "LABELS": {
          "ADDED": "{userName} добавил {labels}",
          "REMOVED": "{userName} удалил {labels}"
        },
        "SLA": {
          "ADDED": "{userName} добавил политику SLA {slaName}",
          "REMOVED": "{userName} удалил политику SLA {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} заглушил(а) этот разговор",
        "UNMUTED": "{userName} включил(а) уведомления для разговора",
        "CONTACT_BLOCKED": "{userName} заблокировал(а) контакт",
        "CONTACT_UNBLOCKED": "{userName} разблокировал(а) контакт",
        "AUTO_RESOLUTION_MESSAGE": "Разговор закрывается, поскольку он был неактивен в течение длительного времени. Пожалуйста, начните новый разговор, если потребуется дополнительная помощь.",
        "DOMAIN_BLOCKED": "{userName} blocked all contacts for a given domain",
        "DOMAIN_UNBLOCKED": "{userName} unblocked all the contacts for a given domain",
        "MOVED": "{userName} moved this conversation from inbox {sourceInboxName} to inbox {targetInboxName}",
        "MOVED_BY_ORDER": "Перемещён, так как заказы контакта есть только в магазине {storeName} (последний заказ {orderId}), робот которого отвечает в этих входящих.",
        "MERGED": "{userName} merged conversation #{sourceId} into this conversation",
        "AUTOMATION_RULE_TRIGGERED": "Automation rule \"{ruleName}\" triggered",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Automation rule \"{ruleName}\" disabled automatic priority",
        "AUTOMATION_SKIP_AUTO_LABELING": "Automation rule \"{ruleName}\" disabled automatic labeling",
        "AUTOMATION_STOP_PROCESSING_RULES": "Automation rule \"{ruleName}\" stopped further rule processing",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Sending message action was skipped for this auto-reply message",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Автоматизация пропущена, так как контакт заблокирован",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "Автоматизация «{ruleName}» не смогла переместить этот диалог из источника {sourceInboxName} в источник {targetInboxName}, так как источники несовместимы.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "Автоматизация «{ruleName}» не смогла переместить этот диалог из источника {sourceInboxName} в источник {targetInboxName}, так как у контакта нет адреса электронной почты.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "Автоматизация «{ruleName}» не смогла отправить сообщение: этот телефонный источник не может отправлять SMS, так как в аккаунте нет источника SMS. Правило отключено, администраторы получили письмо.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Автоматизация «{ruleName}» не смогла отправить сообщение: из этого источника нельзя отправлять вложения по SMS. Правило отключено, администраторы получили письмо.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "Макрос «{macroName}» не отправил сообщение: этот телефонный источник не может отправлять SMS, так как в аккаунте нет источника SMS.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Макрос «{macroName}» не отправил сообщение: из этого источника нельзя отправлять вложения по SMS.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "Макрос «{macroName}» не отправил сообщение: этот диалог обрабатывает бот. Сначала откройте диалог.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "Макрос «{macroName}» не отправил сообщение: этот источник помечен для удаления. Сначала переместите диалог в другой источник.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "Автоматизация «{ruleName}» отправила письмо на {contactEmail} в новом диалоге [#{conversationId}]({conversationPath}) в источнике {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "Автоматизация «{ruleName}» начала этот диалог из-за диалога [#{conversationId}]({conversationPath}) в источнике {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "Автоматизация «{ruleName}» не смогла отправить сообщение в новом диалоге в источнике {inboxName}, так как у контакта нет адреса электронной почты.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "Автоматизация «{ruleName}» отправила SMS на {contactPhone} в новом диалоге [#{conversationId}]({conversationPath}) в источнике {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "Автоматизация «{ruleName}» не смогла отправить SMS в новом диалоге в источнике {inboxName}, так как у контакта нет номера телефона.",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Агент",
            "CUSTOMER": "Клиент"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "ответили на другом аппарате, звонило {duration}",
            "NO_ANSWER": "без ответа, звонило {duration}",
            "REJECTED": "отклонено, звонило {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Решено автоматически после неудачных обратных звонков: {count}",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Запись звонка удалена пользователем {name}, {date}"
        }
      }
    },
    "IMAGE_RESIZE": {
      "SMALL": "Small",
      "MEDIUM": "Medium",
      "LARGE": "Large",
      "ORIGINAL": "Original"
    },
    "SHOW_HIDDEN_MESSAGES": "Show hidden messages",
    "TRANSCRIPT": {
      "SHOW": "Show full transcript",
      "HIDE": "Hide full transcript",
      "DOWNLOAD": "Download transcript",
      "COPY": "Copy transcript"
    },
    "INVISIBLE_TO_CUSTOMER": "Невидимо для клиента",
    "SENT_VIA_EMAIL": "Также отправлено контакту по электронной почте ({time})",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "FACEBOOK_CANNOT_REPLY": "If you need to continue this conversation, ",
    "PENDING_WITH_BOT_BANNER": "This conversation is being handled by AI bot. If you want to reply, open the conversation first.",
    "INBOX_DELETE_REQUESTED_BANNER": "Этот источник помечен для удаления, поэтому ответ клиента никогда не придёт. Чтобы ответить, переместите диалог в другой источник.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "У этого контакта есть другая открытая беседа #{id}",
      "MULTIPLE": "У этого контакта есть другие открытые беседы ({count})",
      "OPEN": "Открыть",
      "SHOW": "Показать"
    },
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won't be able to send messages from this conversation anymore.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Cannot send message because the customer is not online and email continuity is not available.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "The customer is not online. They may not receive messages since email continuity is not available.",
    "OPEN_FILE": "Open",
    "DOWNLOAD_ATTACHMENTS": "Download all",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Download all attachments one by one",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Download all as ZIP",
    "ERROR_DOWNLOADING_FILE": "Error downloading file",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Попросить клиента поделиться номером телефона WhatsApp",
      "PENDING_ACTION": "Запрос контактной информации ожидает ответа",
      "STATES": {
        "PENDING": "Ожидание контактной информации",
        "SHARED": "Номер телефона предоставлен",
        "IDENTITY_CONFLICT": "Номер телефона требует проверки"
      }
    },
    "SLA": {
      "BREACHED": "breached"
    },
    "IMAGE_UPLOAD_ERROR": "Unable to upload image, please try again",
    "DRAFT": {
      "FILE_TOO_LARGE": "File '{fileName}' ({fileSize}) is too large for draft storage and will be skipped",
      "ATTACHMENT_SERIALIZATION_FAILED": "Failed to serialize attachment for draft storage",
      "STORAGE_QUOTA_EXCEEDED": "Storage quota exceeded. Draft saved without attachments",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Failed to save draft even without attachments",
      "SAVE_FAILED": "Failed to save conversation draft"
    },
    "COMMENT_TREE": {
      "TITLE": "Comment thread",
      "EMPTY": "No comments to display",
      "VIEW_TREE": "View comment thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Отправить субтитры разговора",
    "DESC": "Отправить копию субтитров разговора на указанный адрес электронной почты",
    "SUBMIT": "Отправить",
    "CANCEL": "Отменить",
    "SEND_EMAIL_SUCCESS": "Субтитры чата успешно отправлены",
    "SEND_EMAIL_ERROR": "Произошла ошибка, попробуйте еще раз",
    "FORM": {
      "SEND_TO_CONTACT": "Отправить субтитры клиенту",
      "SEND_TO_AGENT": "Отправить транскрипт назначенному агенту",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Отправить субтитры на другой адрес электронной почты",
      "EMAIL": {
        "PLACEHOLDER": "Введите адрес электронной почты",
        "ERROR": "Пожалуйста, введите действительный адрес электронной почты"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Привет 👋, добро пожаловать в {installationName}!",
    "DESCRIPTION": "Спасибо за регистрацию. Мы хотим, чтобы вы получили максимум от {installationName}. Вот несколько вещей, которые вы можете сделать в {installationName}, чтобы получить ещё больше приятных впечатлений.",
    "GREETING_MORNING": "👋 Доброе утро, {name}. Добро пожаловать на {installationName}.",
    "GREETING_AFTERNOON": "👋 Добрый день, {name}. Добро пожаловать на {installationName}.",
    "GREETING_EVENING": "👋 Добрый день, {name}. Добро пожаловать на {installationName}.",
    "READ_LATEST_UPDATES": "Читайте о наших последних обновлениях",
    "ALL_CONVERSATION": {
      "TITLE": "Все ваши диалоги в одном месте",
      "DESCRIPTION": "Посмотреть все разговоры с клиентами в одной панели управления. Вы можете отфильтровать разговоры по входящему каналу, метке и статусу.",
      "NEW_LINK": "Нажмите здесь, чтобы создать входящий канал"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Пригласить членов вашей команды",
      "DESCRIPTION": "Так как вы готовы общаться с клиентом, пригласите в команду своих товарищей, чтобы помочь вам. Вы можете пригласить своих коллег по команде, добавив их адреса электронной почты в список агентов.",
      "NEW_LINK": "Нажмите здесь, чтобы пригласить члена команды"
    },
    "LABELS": {
      "TITLE": "Сгруппировать беседы с помощью меток",
      "DESCRIPTION": "Метки дают более простой способ классифицировать разговор. Создайте несколько меток, например #support-enquiry, #billing-question и т.д., чтобы позже использовать их в беседе.",
      "NEW_LINK": "Нажмите здесь, чтобы создать метки"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Создать шаблонные ответы",
      "DESCRIPTION": "Предварительно написанные шаблонные ответы помогут вам быстро отвечать на диалоги. Агенты могут ввести символ '/' и короткое название, чтобы вставить ответ.",
      "NEW_LINK": "Нажмите здесь, чтобы создать шаблонный ответ"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Назначенный агент",
    "SELF_ASSIGN": "Назначить мне",
    "TEAM_LABEL": "Назначенная команда",
    "SELECT": {
      "PLACEHOLDER": "Ничего"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Custom Data",
      "CONTACT_DETAILS": "Контактные данные",
      "CONVERSATION_ACTIONS": "Действия в беседе",
      "CONVERSATION_LABELS": "Категории Диалога",
      "CONVERSATION_INFO": "Информация о беседе",
      "CONTACT_ATTRIBUTES": "Атрибуты контакта",
      "PREVIOUS_CONVERSATION": "Предыдущие диалоги",
      "MACROS": "Макросс",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "ORDER_HISTORY": "Order History",
      "RETINO_TICKETS": "Retino Tickets"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "В ожидании",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Создать атрибут",
    "NO_RECORDS_FOUND": "Атрибуты не найдены",
    "UPDATE": {
      "SUCCESS": "Атрибут успешно обновлен",
      "ERROR": "Не удается обновить атрибут. Повторите попытку позже"
    },
    "ADD": {
      "TITLE": "Добавить",
      "SUCCESS": "Атрибут успешно добавлен",
      "ERROR": "Невозможно добавить атрибут. Пожалуйста, повторите попытку позже"
    },
    "DELETE": {
      "SUCCESS": "Атрибут успешно удалён",
      "ERROR": "Невозможно удалить атрибут. Пожалуйста, повторите попытку позже"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Добавить атрибуты",
      "PLACEHOLDER": "Поиск атрибутов",
      "NO_RESULT": "Атрибуты не найдены"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "От",
    "TO": "Кому",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Тема"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Участвующие",
    "SIDEBAR_TITLE": "Участники диалога",
    "NO_RECORDS_FOUND": "Результаты не найдены",
    "ADD_PARTICIPANTS": "Выберите участников",
    "REMANING_PARTICIPANTS_TEXT": "+{count} другие",
    "REMANING_PARTICIPANT_TEXT": "+{count} другие",
    "TOTAL_PARTICIPANTS_TEXT": "{count} человек участвуют.",
    "TOTAL_PARTICIPANT_TEXT": "{count} человек участвуют.",
    "NO_PARTICIPANTS_TEXT": "Никто не участвует!.",
    "WATCH_CONVERSATION": "Присоединиться к диалогу",
    "YOU_ARE_WATCHING": "Вы участвуете",
    "API": {
      "ERROR_MESSAGE": "Не удалось обновить, попробуйте снова!",
      "SUCCESS_MESSAGE": "Участники обновлены!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "Просмотреть перевод",
    "DESC": "Вы можете просмотреть содержимое перевода в каждом языке.",
    "ORIGINAL_CONTENT": "Оригинальное содержимое",
    "TRANSLATED_CONTENT": "Перевод",
    "NO_TRANSLATIONS_AVAILABLE": "Для этого содержимого нет доступных переводов"
  },
  "TYPING": {
    "ONE": "{user} печатает",
    "TWO": "{user} и {secondUser} печатают",
    "MULTIPLE": "{user} и {count} печатают",
    "IMAGE_ALT": "Someone is typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Попробуйте эти запросы"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Не удалось загрузить вложение, попробуйте еще раз"
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "No data found",
    "LOAD_ERROR": "Unable to load data. Please try again later."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Load more",
    "NO_RECORDS_FOUND": "No tickets found",
    "LOAD_ERROR": "Unable to load tickets from {hookName}. Please try again later.",
    "NOT_SEARCHABLE": "Contact email is not set.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Loading...",
    "NO_ORDERS": "No orders found",
    "NOT_AVAILABLE": "Customer data not available",
    "EXPAND": "Open customer profile",
    "MORE_ITEMS": "+ {count} items",
    "EXPEDITION_STATUS": "Expedition status",
    "OPEN_DETAIL": "open detail",
    "COPY_ORDER_ID": "Номер заказа",
    "EXTERNAL_ID": "Внешний ID",
    "PAYMENT_TYPE": "Способ оплаты",
    "PAYMENT_DATE": "Дата оплаты",
    "DELIVERY_PROVIDER": "Перевозчик",
    "EXPECTED_DATE_OF_DELIVERY": "Ожидаемая доставка",
    "DATE_OF_DELIVERY": "Доставлено",
    "EXPEDITION_DATE": "Дата отправки",
    "INTERNAL_NOTE": "Заметка магазина",
    "PACKAGE_NUMBER": "Отправление"
  },
  "READING": {
    "ONE": "{user} is reading this ticket",
    "TWO": "{user} and {secondUser} are reading this ticket",
    "MULTIPLE": "{user} and {count} others are reading this ticket"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Move Conversation",
    "DESCRIPTION": "Move this conversation to a different email inbox.",
    "SOURCE": {
      "TITLE": "Conversation",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Destination Inbox",
      "PLACEHOLDER": "Select an email inbox",
      "NO_RESULTS": "No other email inboxes available",
      "ERROR": "Please select a destination inbox"
    },
    "SUBMIT": "Move Conversation",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation moved successfully",
    "ERROR_MESSAGE": "Could not move conversation. Please try again."
  },
  "MERGE": {
    "TITLE": "Merge Conversations",
    "DESCRIPTION": "Merge this conversation with another conversation. All messages from this conversation will be moved to the target conversation, and this conversation will be deleted.",
    "SOURCE": {
      "TITLE": "Source Conversation (will be deleted)",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Target Conversation",
      "PLACEHOLDER": "Type conversation ID to search (e.g., 123)",
      "HELP": "Enter the conversation ID to merge all messages into.",
      "ERROR": "Please select a target conversation"
    },
    "WARNING": "Warning: This action cannot be undone. All messages will be moved to the target conversation and this conversation will be permanently deleted.",
    "SUBMIT": "Merge Conversations",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation merged successfully",
    "ERROR_MESSAGE": "Could not merge conversations. Please check the target conversation and try again.",
    "SEARCH": {
      "NO_RESULTS": "No conversation found with this ID",
      "ERROR_MESSAGE": "Could not search conversations. Please try again."
    },
    "CONFIRM": {
      "TITLE": "Confirm Merge",
      "DESCRIPTION": "Are you sure you want to merge this conversation? This action cannot be undone.",
      "YES": "Yes, Merge",
      "CANCEL": "Cancel"
    }
  }
}
